module.exports = __webpack_public_path__ + "static/img/y59.780ca6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y59.jpg
// module id = iqQZ
// module chunks = 1